const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost';

export async function GetEmpresas(nom?: string, idCurs?: string | number, poblacio?: string) {
    try {
        const params = new URLSearchParams();
        if (nom) params.append('nom', nom);
        if (idCurs && idCurs !== 0 && idCurs !== '0') params.append('idCurs', idCurs.toString());
        if (poblacio) params.append('poblacio', poblacio);

        const response = await fetch(`${baseUrl}:8061/metadata/empresas?${params.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
        });

        if (response.ok) {
            return await response.json();
        } else {
            return [];
        }
    } catch (error) {
        console.error('Error fetching empresas:', error);
        return [];
    }
}
